import script from "./SouthboundPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SouthboundPage.vue?vue&type=script&setup=true&lang=js"

import "./SouthboundPage.vue?vue&type=style&index=0&id=b150df54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b150df54"]])

export default __exports__